import { Flex, Tab, Tabs } from "@braze/beacon-core"
import { useState } from "react";
import { ParentCampaignsTable } from "../../components/settings/ParentCampaignsTable";
import { Programs } from "../../components/settings/Programs";
import { DeleteCampaigns } from "../../components/settings/DeleteCampaigns";

export const Settings = () => {

    const [activeTab, setActiveTab] = useState<number|string>(1);
    
    return (
        <Flex direction="column" style={{width: "80%", marginTop: "1rem"}}>
            <Tabs activeTab={activeTab} onChange={(tabId: number|string)=> setActiveTab(tabId)}>
                <Tab tabId={1}>
                    Parent Campaigns
                </Tab>
                <Tab tabId={2}>
                    Programs
                </Tab>
                <Tab tabId={3}>
                    Delete Campaign
                </Tab>
            </Tabs>
            <SharedTabsContent id={activeTab}/>
        </Flex>
    )
}

const SharedTabsContent = ({id} : {id : number|string}) => {

    if (id === 1) {
        return <ParentCampaignsTable/>
    } 
    else if (id === 2) {return <Programs/>}
    else if (id === 3) {return <DeleteCampaigns/>}
    return (
        <>
        </>
    )
}